import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "604ff4df-0de1-440e-a770-9da27e5f5713",
  title: "Base Training: Pfitzinger/Latter: Up to 45 miles per week, 10-week schedule",
  raceType: "Base",
  units: "miles",
  workouts: [
    // Week 1
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Endurance 9 miles",
      totalDistance: 9,
    },
    // Week 2
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Endurance 10 miles",
      totalDistance: 10,
    },
    // Week 3
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 6 miles",
      totalDistance: 6,
    },
    {
      description: "Endurance 10 miles",
      totalDistance: 10,
    },
    // Week 4
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "General aerobic 6 miles w/ 8x100m strides",
      totalDistance: 6,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Endurance 10 miles",
      totalDistance: 10,
    },
    // Week 5
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "Lactate threshold 7 miles w/ 18 min tempo",
      totalDistance: 7,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "Endurance 11 miles",
      totalDistance: 11,
    },
    // Week 6
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "General aerobic 3 miles",
      totalDistance: 3,
    },
    {
      description: "General aerobic 7 miles w/ 8x100m strides",
      totalDistance: 7,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "Endurance 11 miles",
      totalDistance: 11,
    },
    // Week 7
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Lactate threshold 8 miles w/ 20 min tempo",
      totalDistance: 8,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "Endurance 11 miles",
      totalDistance: 11,
    },
    // Week 8
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic 8 miles w/ 8x100m strides",
      totalDistance: 8,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    // Week 9
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 4 miles",
      totalDistance: 4,
    },
    {
      description: "Lactate threshold 8 miles w/ 22 min tempo",
      totalDistance: 8,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    // Week 10
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "General aerobic 5 miles",
      totalDistance: 5,
    },
    {
      description: "General aerobic 8 miles w/ 8x100m strides",
      totalDistance: 8,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
  ]
} as BuiltInPlan;